export const smoothScrollTo = (id: string) => {
	const element = document.getElementById(id)
	if (!element) return

	const fixedHeaderHeight = document.querySelector('header')?.offsetHeight ?? 0
	const scrollPosition = element.getBoundingClientRect().top + window.scrollY - fixedHeaderHeight

	window.scroll({
		top: scrollPosition,
		behavior: 'smooth',
	})
}
